import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

/* Formata a quantidade/valor com 4 casas decimais */
const formatQuantidade = (valor) => {
    return Number(valor || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
    });
};

class MercadoriaList extends Component {
    state = {
        searchFilter: loadStoredJson('mercadoriaSearchFilter', {
            descmercadoria: '',
            codmercadoria: '',
            codigodebarras: '',
            ncm: '',
            situacaoInativoFilter: ANAO
        }),
        mercadorias: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('mercadoriaPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('mercadoriaRowsPerPage')) || 10
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;
        this.loadMercadorias();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('mercadoriaSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('mercadoriaPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('mercadoriaRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'mercadoriaSearchFilter',
            'mercadoriaPage',
            'mercadoriaRowsPerPage'
        ]);
    };

    /* Carrega as mercadorias */
    loadMercadorias = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;

        const {
            codigodebarras,
            codmercadoria,
            descmercadoria,
            ncm,
            situacaoInativoFilter
        } = searchFilter;

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: [
                {
                    field: 'DESCMERCADORIA',
                    value: descmercadoria,
                    operator: '_like_'
                },
                {
                    field: 'CODMERCADORIA',
                    value: codmercadoria
                },
                {
                    field: 'CODIGODEBARRAS',
                    value: codigodebarras,
                    operator: '_like_'
                },
                {
                    field: 'NCM',
                    value: ncm,
                    operator: '_like_'
                },
                {
                    field: 'INATIVO',
                    value: situacaoInativoFilter
                }
            ]
        });

        try {
            const response = await api.get('/mercadoria' + params);

            this.safeSetState({
                mercadorias: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar mercadorias:', error);

            this.safeSetState({
                mercadorias: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadMercadorias);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadMercadorias);
    };

    /* Deleta a mercadoria */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/mercadoria/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadMercadorias();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir mercadoria!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codmercadoria, descmercadoria) => {
        this.setState({
            open: true,
            selectedId: codmercadoria,
            selectedDesc: descmercadoria
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            descmercadoria: '',
            codmercadoria: '',
            codigodebarras: '',
            ncm: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadMercadorias);
    };

    render() {
        const {
            messageAlert,
            mercadorias,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="descmercadoria"
                        name="descmercadoria"
                        onChange={this.onChangeSearch}
                        placeholder="Mercadoria"
                        value={searchFilter.descmercadoria}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Input
                        id="codmercadoria"
                        name="codmercadoria"
                        onChange={this.onChangeSearch}
                        placeholder="Código"
                        value={searchFilter.codmercadoria}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100
                        }}
                    />

                    <Input
                        id="codigodebarras"
                        name="codigodebarras"
                        onChange={this.onChangeSearch}
                        placeholder="Cód. barras"
                        value={searchFilter.codigodebarras}
                        style={{
                            flex: '0 1 150px',
                            minWidth: 150
                        }}
                    />

                    <Input
                        id="ncm"
                        name="ncm"
                        onChange={this.onChangeSearch}
                        placeholder="NCM"
                        value={searchFilter.ncm}
                        style={{
                            flex: '0 1 120px',
                            minWidth: 120
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadMercadorias}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/estoque/mercadoria/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                Código
                                            </TableCell>

                                            <TableCell align="center">
                                                Descrição
                                            </TableCell>

                                            <TableCell align="center">
                                                NCM
                                            </TableCell>

                                            <TableCell align="center">
                                                Saldo almox.
                                            </TableCell>

                                            <TableCell align="center">
                                                Custo últ. compra
                                            </TableCell>

                                            <TableCell align="center">
                                                Ações
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {mercadorias.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={6}
                                                >
                                                    Nenhuma mercadoria encontrada
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {mercadorias.map(mercadoria => (
                                            <TableRow
                                                hover
                                                key={mercadoria.codmercadoria}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(mercadoria.inativo === ASIM) ? redText : {}}
                                                >
                                                    {mercadoria.codmercadoria}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(mercadoria.inativo === ASIM) ? redText : {}}
                                                >
                                                    {mercadoria.descmercadoria}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(mercadoria.inativo === ASIM) ? redText : {}}
                                                >
                                                    {mercadoria.ncm}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(mercadoria.inativo === ASIM) ? redText : {}}
                                                >
                                                    {formatQuantidade(mercadoria.saldoalmox)}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(mercadoria.inativo === ASIM) ? redText : {}}
                                                >
                                                    {formatQuantidade(mercadoria.valultcompalmox)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/estoque/mercadoria/${mercadoria.codmercadoria}`}>
                                                                <EditTwoTone
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/estoque/mercadoria/${mercadoria.codmercadoria}/view`}>
                                                                <VisibilityOutlined
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlined
                                                                onClick={() => this.handleOpen(
                                                                    mercadoria.codmercadoria,
                                                                    mercadoria.descmercadoria
                                                                )}
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão da mercadoria ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default MercadoriaList;